// Models
PJQ.models.punchlists.PunchlistItem = PJQ.models.BaseModel.extend({
    notifyName: 'Punch List Item',
    idAttribute: "punchlistItemId",
    endpoint: function () {
        let arr;
        if (this.get('projectId') > 0) {
            arr = [
                {
                    endpoint: 'projects',
                    value: this.get('projectId')
                },
                {
                    endpoint: 'punchlists',
                    value: this.id
                }
            ];
        } else if (this.isNew() && this.get('templateId') > 0) {
            arr = [
                {
                    endpoint: 'punchlists'
                },
                {
                    endpoint: 'templates',
                    value: this.get('templateId')
                },
                {
                    endpoint: 'item'
                }
            ];
        } else {
            arr = [
                {
                    endpoint: 'punchlists',
                    value: this.id
                }
            ];
        }

        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    },
    afterInit: function () {
        if (this.get('customFieldValues') == null) {
            this.set('customFieldValues', [], {
                silent: true
            });
        }

        this.on('change:assignedTo', _.bind(function () {
            let assignedTo = this.get('assignedTo');
            if (assignedTo instanceof PJQ.models.projectContacts.ProjectContact) {
                this.assignedTo = this.get('assignedTo');
            } else if (assignedTo != null) {
                this.assignedTo = new PJQ.models.projectContacts.ProjectContact(this.get('assignedTo'));
            } else {
                this.assignedTo = null;
            }

            if (this.get('status') === PJQ.constants.punchlists.statuses.NEW || PJQ.constants.punchlists.statuses.NOT_RESOLVED) {
                this.ballInCourt = this.assignedTo;
                this.set('ballInCourt', this.ballInCourt);
            }
        }, this));
    },
    parse: function (model) {
        if (!model)
            return model;

        this.groups = new PJQ.collections.groups.Groups(model.groups);

        if (model.createdBy != null) {
            this.createdBy = new PJQ.models.projectContacts.ProjectContact(model.createdBy);
        } else {
            this.createdBy = null;
        }

        if (model.assignedTo) {
            this.assignedTo = new PJQ.models.projectContacts.ProjectContact(model.assignedTo);
        } else {
            this.assignedTo = null;
        }

        if (_.size(model.distributionList) > 0) {
            this.distributionList = new PJQ.collections.projectContacts.ProjectContacts(model.distributionList);
        } else if (!this.distributionList) {
            this.distributionList = new PJQ.collections.projectContacts.ProjectContacts();
        }

        // if (model.workCompletedBy) {
        //     this.workCompletedBy = new PJQ.models.projectContacts.ProjectContact(model.workCompletedBy);
        // }
        // else{
        //     this.workCompletedBy = null;
        // }
        //
        // if (model.resolvedBy) {
        //     this.resolvedBy = new PJQ.models.projectContacts.ProjectContact(model.resolvedBy);
        // }
        // else{
        //     this.resolvedBy = null;
        // }

        if (_.size(model.comments) > 0) {
            this.comments = new PJQ.collections.punchlists.PunchlistItemComments(model.comments);
        } else {
            this.comments = new PJQ.collections.punchlists.PunchlistItemComments();
        }

        if (_.size(model.attachments) > 0) {
            this.attachments = new PJQ.collections.punchlists.PunchlistItemAttachments(model.attachments);
        } else {
            this.attachments = new PJQ.collections.punchlists.PunchlistItemAttachments();
        }

        if (_.size(model.beforeAttachments) > 0) {
            this.beforeAttachments = new PJQ.collections.punchlists.PunchlistItemAttachments(model.beforeAttachments);
        } else {
            this.beforeAttachments = new PJQ.collections.punchlists.PunchlistItemAttachments();
        }

        if (_.size(model.afterAttachments) > 0) {
            this.afterAttachments = new PJQ.collections.punchlists.PunchlistItemAttachments(model.afterAttachments);
        } else {
            this.afterAttachments = new PJQ.collections.punchlists.PunchlistItemAttachments();
        }

        if (model.customFieldValues == null) {
            model.customFieldValues = [];
        }

        return model;
    },
    getDeepLink: function () {
        let projectId = this.get('projectId');
        if (!(this.id > 0) || !(projectId > 0)) {
            return null;
        }
        return '#projects/' + projectId.toString() + '/punchlists/' + this.id.toString();
    },
    getStatusColor: function () {
        if (this.get('status') == null) {
            this.set('status', PJQ.constants.punchlists.statuses.NEW);
        }

        if (this.assignedTo != null && this.get('status') === PJQ.constants.punchlists.statuses.NEW) {
            return PJQ.constants.punchlists.statusColors[PJQ.constants.punchlists.statuses.ASSIGNED];
        }
        return PJQ.constants.punchlists.statusColors[this.get('status')];
    },
    getStatusName: function () {
        if (this.get('status') == null) {
            this.set('status', PJQ.constants.punchlists.statuses.NEW);
        }

        if (this.assignedTo != null && this.get('status') === PJQ.constants.punchlists.statuses.NEW) {
            return PJQ.constants.punchlists.statusNames[PJQ.constants.punchlists.statuses.ASSIGNED];
        } else if (this.get('status') === PJQ.constants.punchlists.statuses.WORK_COMPLETED) {
            let workCompletedOverride = PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PUNCH_LIST_WORK_COMPLETED_STATUS_OVERRIDE);
            if (workCompletedOverride != null) {
                return workCompletedOverride;
            }
        }
        return PJQ.constants.punchlists.statusNames[this.get('status')];
    },
    getPriorityColor: function () {
        if (this.get('priority') == null) {
            this.set('priority', PJQ.constants.punchlists.priorities.LOW);
        }
        return PJQ.constants.punchlists.priorityColors[this.get('priority')];
    },
    getPriorityName: function () {
        if (this.get('priority') == null) {
            this.set('priority', PJQ.constants.punchlists.priorities.LOW);
        }
        return PJQ.constants.punchlists.priorityNames[this.get('priority')];
    },
    beforeSave: function () {
        this.set({
            groups: this.groups.toJSON(),
            assignedTo: this.assignedTo?.toJSON(),
            distributionList: this.distributionList.toJSON(),
            attachments: this.attachments.getChangedModels(),
            beforeAttachments: this.beforeAttachments.getChangedModels(),
            afterAttachments: this.afterAttachments.getChangedModels(),
            comments: this.comments.getChangedModels()
        });
    },
    fetchNotifications: function (callback) {
        if (this.notifications == null) {
            this.notifications = new PJQ.collections.punchlists.Notifications(null, {
                punchlistItem: this
            })
        }

        this.notifications.fetch({
            success: _.bind(function () {
                callback(this.notifications);
            }, this)
        });
    },
    distribute: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/distribute',
        }).post().done((response) => {
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((res) => {
            let err = null;
            if (res.responseJSON && res.responseJSON.message) {
                err = res.responseJSON.message;
            }
            if (typeof callback === 'function') {
                callback(false, err);
            }
        });
    },
});

PJQ.models.punchlists.PunchlistItemComment = PJQ.models.BaseModel.extend({
    idAttribute: "commentId",
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'punchlists',
                value: this.get('punchlistItemId')
            },
            {
                endpoint: 'comments',
                value: this.get('commentId')
            }
        ])
    },
    parse: function (model) {
        if (!model) {
            return model;
        }

        if (model.createdBy != null) {
            this.createdBy = new PJQ.models.projectContacts.ProjectContact(model.createdBy);
        }

        return model;
    }
});

PJQ.models.punchlists.EditHistoryItem = PJQ.models.BaseModel.extend({
    parse: function (model) {
        if (!model)
            return model;

        this.createdOnDisplay = PJQ.helpers.dateHelpers.getDateString(new Date(model.createdOn), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true);

        this.createdByDisplay = '';

        if (model.createdBy && model.createdBy.companyName)
            this.createdByDisplay = model.createdBy.contactName + ' (' + model.createdBy.companyName + ')';

        this.oldValueDisplay = model.oldValue;
        this.newValueDisplay = model.newValue;

        if (model.fieldType === 'DATE') {
            if (model.oldValue)
                this.oldValueDisplay = PJQ.helpers.dateHelpers.getDateString(new Date(model.oldValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
            if (model.newValue)
                this.newValueDisplay = PJQ.helpers.dateHelpers.getDateString(new Date(model.newValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
        } else if (model.fieldType === 'DATETIME') {
            if (model.oldValue)
                this.oldValueDisplay = PJQ.helpers.dateHelpers.getDateString(new Date(model.oldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true);
            if (model.newValue)
                this.newValueDisplay = PJQ.helpers.dateHelpers.getDateString(new Date(model.newValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true);
        }

        return model;
    }
});

PJQ.models.punchlists.PunchlistItemAttachment = PJQ.models.files.File.extend({
    idAttribute: 'attachmentId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'punchlists',
                value: this.get('punchlistItemId')
            },
            {
                endpoint: 'attachments',
                value: this.id
            }
        ]);
    }
});

PJQ.models.punchlists.PunchlistCustomField = PJQ.models.customFields.CustomField.extend({
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'punchlists'
            },
            {
                endpoint: 'customFields',
                value: this.id
            }
        ])
    }
});

PJQ.models.punchlists.Notification = PJQ.models.notifications.Notification.extend({
    notificationTypeNames: PJQ.constants.punchlists.notificationTypeNames,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'punchlists',
                value: this.collection.options.punchlistItem.id
            },
            {
                endpoint: 'notifications',
                value: this.id
            }
        ])
    }
});

PJQ.models.punchlists.Settings = PJQ.models.BaseModel.extend({
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.get('project').id
            },
            {
                endpoint: 'punchlists'
            },
            {
                endpoint: 'settings'
            }
        ])
    },
    parse: function (model) {
        if (!model)
            return model;

        this.projectContacts = new PJQ.collections.punchlists.ProjectContactSettings(model.projectContacts);
        _.each(this.projectContacts.models, _.bind(function (setting) {
            let matchProjectContact = PJQ.app.session.project.projectContacts.findWhere({id: setting.get('id')});
            if (matchProjectContact != null) {
                setting.set(matchProjectContact.attributes, {
                    isSilent: true
                });
            }
        }, this));

        return model;
    },
    beforeSave: function () {
        this.set('projectContacts', this.projectContacts.filter(function (projectContact) {
            return projectContact.hasChanged();
        }));
    }
});

PJQ.models.punchlists.PunchListUserSettings = PJQ.models.BaseModel.extend({
    endpoint: function () {
        let params = [];
        if (this.options.forCompany) {
            params.push({
                parameter: 'forCompany',
                value: true
            });
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'punchlists'
            },
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'user'
            }
        ], params);
    },
    getSettings: function (view) {
        return _.find(this.attributes.viewSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));
    }
});


PJQ.models.punchlists.ProjectContactSetting = PJQ.models.BaseModel.extend({});

PJQ.models.punchlists.Template = PJQ.models.BaseModel.extend({
    idAttribute: 'templateId',
    notifyName: 'Template',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'punchlists'
            },
            {
                endpoint: 'templates',
                value: this.id
            }
        ], this.get('projectId') > 0 ? [
            {
                parameter: 'projectId',
                value: this.get('projectId')
            },
            {
                parameter: 'copyComments',
                value: this.get('copyComments')
            },
            {
                parameter: 'copyAssignee',
                value: this.get('copyAssignee')
            },
            {
                parameter: 'copyGroups',
                value: this.get('copyGroups')
            },
            {
                parameter: 'overwrite',
                value: this.get('overwrite')
            }
        ] : null);
    },
    parse: function (model) {
        if (!model)
            return model;

        if (model.project != null) {
            this.project = model.project;
        } else {
            this.user = PJQ.app.session.user;
        }

        this.groups = new PJQ.collections.groups.Groups(model.groups);

        if (model.createdBy != null) {
            this.createdBy = new PJQ.models.projectContacts.ProjectContact(model.createdBy);
        } else {
            this.createdBy = null;
        }

        if (model.assignee != null) {
            this.assignee = new PJQ.models.projectContacts.ProjectContact(model.assignee);
        } else {
            this.submitter = null;
        }

        this.comments = new PJQ.collections.submittals.Comments(model.comments);

        this.attachments = new PJQ.collections.submittals.Attachments(model.attachments);

        if (model.punchlistItems)
            this.punchlistItems = new PJQ.collections.punchlists.PunchlistItems(model.punchlistItems);
        else if (model.items)
            this.punchlistItems = new PJQ.collections.punchlists.PunchlistItems(model.items);
        else
            this.punchlistItems = new PJQ.collections.punchlists.PunchlistItems();

        return model;
    }
});


// Collections
PJQ.collections.punchlists.PunchlistItems = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.punchlists.PunchlistItem,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'punchlists'
            }
        ])
    }
});

PJQ.collections.punchlists.Notifications = PJQ.collections.notifications.Notifications.extend({
    model: PJQ.models.punchlists.Notification,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'punchlists',
                value: this.options.punchlistItem.id
            },
            {
                endpoint: 'notifications'
            }
        ])
    }
});

PJQ.collections.punchlists.EditHistoryItems = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.punchlists.EditHistoryItem
});

PJQ.collections.punchlists.PunchlistItemComments = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.punchlists.PunchlistItemComment
});

PJQ.collections.punchlists.PunchlistItemAttachments = PJQ.collections.files.Files.extend({
    model: PJQ.models.punchlists.PunchlistItemAttachment
});

PJQ.collections.punchlists.ProjectContactSettings = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.punchlists.ProjectContactSetting
});

PJQ.collections.punchlists.PunchlistCustomFields = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.punchlists.PunchlistCustomField,
    options: {
        masterUserId: null
    },
    endpoint: function () {
        let projectId = null;
        if (this.options.project != null) {
            projectId = this.options.project.id
        } else if (this.options.projectId > 0) {
            projectId = this.options.projectId;
        }

        if (projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: projectId
                },
                {
                    endpoint: 'punchlists'
                },
                {
                    endpoint: 'customFields'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'punchlists'
                },
                {
                    endpoint: 'customFields'
                }
            ],
            [
                {
                    parameter: 'masterUserId',
                    value: this.options.masterUserId > 0 ? this.options.masterUserId : PJQ.app.session.get('masterUserId')
                }
            ]);
    }
});

PJQ.collections.punchlists.Templates = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.punchlists.Template,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'punchlists'
            },
            {
                endpoint: 'templates'
            }
        ]);
    }
});
